import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import random from 'lodash/random';

import store from 'Redux/store';
import { addVoucher } from 'Redux/ducks/voucher';

const KeyReveals = {};

// Match the wheel segment with the prize won
KeyReveals.getWheelNumber = (productName) => {
  let wheelNumber = 0;
  switch (productName) {
    case 'redeem:DRAGON BALL: Sparking! ZERO':
      wheelNumber = 1;
      break;
    case 'voucher:BLACK FRIDAY FREE SPIN - 7%':
      wheelNumber = 2;
      break;
    case 'Dreamscaper':
      wheelNumber = 3;
      break;
    case 'voucher:BLACK FRIDAY FREE SPIN - $10':
      wheelNumber = 4;
      break;
    case 'UNDETECTED':
      wheelNumber = 5;
      break;
    case 'Tinytopia':
      wheelNumber = 7;
      break;
    case 'Astronarch':
      wheelNumber = 8;
      break;
    case 'redeem:Warhammer 40,000: Space Marine 2':
      wheelNumber = 9;
      break;
    case 'voucher:BLACK FRIDAY FREE SPIN - $2':
      wheelNumber = 10;
      break;
    case 'Hammerwatch Anniversary Edition':
      wheelNumber = 11;
      break;
    case 'voucher:BLACK FRIDAY FREE SPIN - $500 SPEND SPREE':
      wheelNumber = 12;
      break;
    case 'Coromon':
      wheelNumber = 13;
      break;
    case 'Omen Exitio: Plague':
      wheelNumber = 14;
      break;
    case 'GoNNER':
      wheelNumber = 15;
      break;
    case 'voucher:BLACK FRIDAY FREE SPIN - $1':
      wheelNumber = 16;
      break;
    case 'DESOLATE':
      wheelNumber = 17;
      break;
    case 'DESOLATE (RECLAIMED KEYS)':
      wheelNumber = 17;
      break;
    default:
      wheelNumber = 6;
  }
  return wheelNumber;
};

// Test item for the wheel
KeyReveals.getTestWheelNumber = () => {
  const testKeys = [
    'redeem:DRAGON BALL: Sparking! ZERO',
    'voucher:BLACK FRIDAY FREE SPIN - 7%',
    'Dreamscaper',
    'voucher:BLACK FRIDAY FREE SPIN - $10',
    'UNDETECTED',
    'Tinytopia',
    'Astronarch',
    'redeem:Warhammer 40,000: Space Marine 2',
    'voucher:BLACK FRIDAY FREE SPIN - $2',
    'Hammerwatch Anniversary Edition',
    'voucher:BLACK FRIDAY FREE SPIN - $500 SPEND SPREE',
    'Coromon',
    'Omen Exitio: Plague',
    'GoNNER',
    'voucher:BLACK FRIDAY FREE SPIN - $1',
    'DESOLATE',
  ];
  const randomNum = random(0, testKeys.length - 1);
  return testKeys[randomNum];
};

// Match the wheel alt segment with the prize won
KeyReveals.getAltWheelNumber = (productName) => {
  let wheelNumber = 0;
  switch (productName) {
    case 'Congratulations - You have won the Jingle Jam Star Prizes':
      wheelNumber = 1;
      break;
    case 'voucher:Jingle Jam Spin to Win - 10% Coupon':
      wheelNumber = 2;
      break;
    case 'Black Myth: Wukong Digital Deluxe Edition':
      wheelNumber = 3;
      break;
    case 'voucher:Jingle Jam Spin to Win - $10 Coupon':
      wheelNumber = 4;
      break;
    case 'GoNNER':
      wheelNumber = 5;
      break;
    case 'Guts and Glory':
      wheelNumber = 7;
      break;
    case 'voucher:Jingle Jam Spin to Win - 25% Coupon':
      wheelNumber = 8;
      break;
    case 'DESOLATE':
      wheelNumber = 9;
      break;
    case 'DESOLATE (RECLAIMED KEYS)':
      wheelNumber = 9;
      break;
    case 'voucher:Jingle Jam Spin to Win - $2 Coupon':
      wheelNumber = 10;
      break;
    case 'redeem:Warhammer 40,000: Space Marine 2 - Jingle Jam':
      wheelNumber = 11;
      break;
    case 'redeem:DRAGON BALL: Sparking! ZERO - Jingle Jam':
      wheelNumber = 12;
      break;
    case 'Dread X Collection':
      wheelNumber = 13;
      break;
    case 'voucher:Jingle Jam Spin to Win - 15% Coupon':
      wheelNumber = 14;
      break;
    case 'Hotshot Racing':
      wheelNumber = 15;
      break;
    case 'Hotshot Racing (RECLAIMED KEYS)':
      wheelNumber = 15;
      break;
    case 'voucher:Jingle Jam Spin to Win - $1 Coupon':
      wheelNumber = 16;
      break;
    case 'redeem:SILENT HILL 2 - Jingle Jam':
      wheelNumber = 17;
      break;
    default:
      wheelNumber = 6;
  }
  return wheelNumber;
};

// Test item for the wheel alt
KeyReveals.getAltTestWheelNumber = () => {
  const testKeys = [
    'Congratulations - You have won the Jingle Jam Star Prizes',
    'voucher:Jingle Jam Spin to Win - 10% Coupon',
    'Black Myth: Wukong Digital Deluxe Edition',
    'voucher:Jingle Jam Spin to Win - $10 Coupon',
    'GoNNER',
    'Guts and Glory',
    'voucher:Jingle Jam Spin to Win - 25% Coupon',
    'DESOLATE',
    'voucher:Jingle Jam Spin to Win - $2 Coupon',
    'redeem:Warhammer 40,000: Space Marine 2 - Jingle Jam',
    'redeem:DRAGON BALL: Sparking! ZERO - Jingle Jam',
    'Dread X Collection',
    'voucher:Jingle Jam Spin to Win - 15% Coupon',
    'Hotshot Racing',
    'voucher:Jingle Jam Spin to Win - $1 Coupon',
    'redeem:SILENT HILL 2 - Jingle Jam',
  ];
  const randomNum = random(0, testKeys.length - 1);
  return testKeys[randomNum];
};

// Test games for the Pinata. This currently returns 1 item in an array but it could be more if needed.
// The carousel in MysteryRevealGames will handle this.
KeyReveals.getTestPinataGames = () => {
  const testKeys = [
    {
      cover: '90aa2ac7-1abc-446b-aa4e-54fec09de481.jpeg',
      name: 'Hands of Necromancy',
      _id: Math.random(),
    },
    {
      cover: '407065f8-90c5-4008-b03e-a15cec48f3ec.jpeg',
      name: 'Karma City Police',
      _id: Math.random(),
    },
    {
      cover: 'e5b66441-6cff-424a-8c2d-7e9aa837c012.jpeg',
      name: 'Osteoblasts',
      _id: Math.random(),
    },
    {
      cover: '84522108-e0d9-4c96-ba2e-382763b31c2b.jpeg',
      name: 'Dreamscaper',
      _id: Math.random(),
    },
    {
      cover: 'a207abe7-56dd-42be-a684-b955a9ca31c9.jpeg',
      name: 'Peachleaf Pirates',
      _id: Math.random(),
    },
    {
      cover: '4837df0f-bed6-4149-a18e-e249e08cb7ee.jpeg',
      name: 'UNDETECTED',
      _id: Math.random(),
    },
    {
      cover: 'cc1a1278-07df-439f-b103-c0beaab170a6.jpg',
      name: 'The Indie Mixtape',
      _id: Math.random(),
    },
    {
      cover: '04e0632d-633b-4c1e-a367-ac3b2897923d.jpeg',
      name: 'Just Die Already',
      _id: Math.random(),
    },
    {
      cover: '65b29bbd-fd6c-4f14-9820-84b36452d93b.jpg',
      name: 'Hue',
      _id: Math.random(),
    },
    {
      cover: '31a627de-9f1f-4b1f-aa44-091e34f39f93.jpeg',
      name: 'Behind the Frame: The Finest Scenery',
      _id: Math.random(),
    },
    {
      cover: 'f0be956a-7377-49a1-8f79-207007999e2f.jpeg',
      name: 'Unity of Command II',
      _id: Math.random(),
    },
    {
      cover: '8b3dfed9-6bc1-494c-b150-092f944f07a7.jpeg',
      name: 'Super Crazy Rhythm Castle',
      _id: Math.random(),
    },
    {
      cover: '0218a98a-fc2f-44a3-8792-6128bc503910.jpeg',
      name: 'Drug Dealer Simulator',
      _id: Math.random(),
    },
    {
      cover: 'd04f157c-1599-4537-b874-ad65cb024820.jpeg',
      name: 'Dying Light 2 Stay Human: Reloaded Edition',
      _id: Math.random(),
    },
    {
      cover: '5dacbc75-e1b8-46d1-942e-b3e4174d701b.jpeg',
      name: 'Dead Island 2 - Gold Edition',
      _id: Math.random(),
    },
    {
      cover: '6df99e39-2751-4b6e-9c0c-a5650a0cc52c.jpeg',
      name: 'Ghost of Tsushima DIRECTOR\'S CUT',
      _id: Math.random(),
    },
    {
      cover: '8fbe28d9-86a3-4a8f-83f8-428a23fcd0ca.jpeg',
      name: 'V Rising',
      _id: Math.random(),
    },
  ];
  const randomNum = random(0, testKeys.length - 1);
  return [testKeys[randomNum]];
};

// Test game for the gift box. Returns 1 game.
KeyReveals.getTestGiftBoxGame = () => {
  const testKeys = [
    {
      cover: '4bafe28d-50ef-41be-9242-8730d04b9cf0.jpeg',
      name: 'Monster Train',
      _id: Math.random(),
    },
    {
      cover: 'a0531b4c-f54f-4dde-ab90-0cc5f2029302.jpeg',
      name: 'One More Island',
      _id: Math.random(),
    },
    {
      cover: '5b5b77a1-dfef-4643-ac17-fe0712d6d32d.jpeg',
      name: 'Valfaris',
      _id: Math.random(),
    },
    {
      cover: '34757cc5-97a2-414c-903a-96b0df59d595.jpeg',
      name: 'Overloop',
      _id: Math.random(),
    },
    {
      cover: 'c37515c9-fdb2-46e0-a407-88eb273f1fe2.jpeg',
      name: 'Grotto',
      _id: Math.random(),
    },
    {
      cover: 'db264790-42af-469b-a2c9-4647acd3c5c1.jpeg',
      name: 'Tormentor❌Punisher',
      _id: Math.random(),
    },
    {
      cover: 'f70ef246-9875-4af8-8cd0-e53d3201f583.jpeg',
      name: 'The Hive',
      _id: Math.random(),
    },
    {
      cover: 'b1e86f71-abe8-4e30-b1c0-25a033d4b0c1.jpeg',
      name: 'The Haunted Island, a Frog Detective Game',
      _id: Math.random(),
    },
    {
      cover: '73307ef2-2591-4b3e-a117-26e6d9f782d8.jpeg',
      name: 'Crumble',
      _id: Math.random(),
    },
    {
      cover: '8a99bfdc-ccd1-46cf-ad4a-9c3ac2d6953c.jpeg',
      name: 'Behold the Kickmen',
      _id: Math.random(),
    },
    {
      cover: '55adbeda-cd49-443b-ac5c-c25aa99a5a3a.jpeg',
      name: 'Hotshot Racing',
      _id: Math.random(),
    },
    {
      cover: '496d6bbe-2d6a-4198-94ee-efbd8ba07b7d.jpeg',
      name: 'Warhammer 40,000: Space Marine 2',
      _id: Math.random(),
    },
    {
      cover: '1fe33518-7aee-4853-8c72-9530be4e2797.jpeg',
      name: 'DRAGON BALL: Sparking! ZERO',
      _id: Math.random(),
    },
    {
      cover: 'a91dab37-38d9-4d37-aebe-5daf8fde0ca8.jpeg',
      name: 'SILENT HILL 2',
      _id: Math.random(),
    },
    {
      cover: '068ecbe4-55d4-4437-ba08-314ebb3413da.jpeg',
      name: 'Black Myth: Wukong',
      _id: Math.random(),
    },
  ];
  const randomNum = random(0, testKeys.length - 1);
  return testKeys[randomNum];
};

// Test game for the envelope. Returns 1 game.
KeyReveals.getTestEnvelopeGame = () => {
  const testKeys = [
    {
      cover: 'b4b9b83f-dc18-4c5d-a41b-03a9a0330a83.jpeg',
      name: 'Mindustry',
      _id: Math.random(),
    },
    {
      cover: 'abbeed05-5d2e-487f-a523-9cc08b5cd8d8.jpeg',
      name: 'Troublemaker',
      _id: Math.random(),
    },
    {
      cover: 'a432af18-be0f-4b5b-896a-bdeebe047a19.jpeg',
      name: 'Blade Assault',
      _id: Math.random(),
    },
    {
      cover: '4dac25e7-d361-468e-abe7-5f548895f0c0.jpeg',
      name: 'Andro Dunos II',
      _id: Math.random(),
    },
    {
      cover: '653e9f56-6e6a-4e76-a903-8333ababec15.jpg',
      name: 'Pharaonic',
      _id: Math.random(),
    },
    {
      cover: 'a2c71b32-2cef-40ec-bc66-c1c71d27cb7a.jpg',
      name: 'King\'s Bounty: Warriors of the North - Valhalla Edition',
      _id: Math.random(),
    },
    {
      cover: '30c505b2-7ecc-4a11-85e3-33b86800fb73.jpeg',
      name: 'Bloodshore',
      _id: Math.random(),
    },
    {
      cover: 'acf4b410-ea82-42eb-a6b3-c10e6149d1cc.jpeg',
      name: 'The Shapeshifting Detective',
      _id: Math.random(),
    },
    {
      cover: 'ba0e9af5-3342-4725-bda2-476febb487bc.jpeg',
      name: 'Those Who Remain',
      _id: Math.random(),
    },
    {
      cover: 'c86ef91d-5987-44ce-8031-2c14d579f96a.jpeg',
      name: 'Lost Words: Beyond the Page',
      _id: Math.random(),
    },
    {
      cover: '57d977f1-68ba-45d3-9c19-5ebe7ea93c3d.jpg',
      name: 'White Noise 2',
      _id: Math.random(),
    },
    {
      cover: 'c37515c9-fdb2-46e0-a407-88eb273f1fe2.jpeg',
      name: 'Grotto',
      _id: Math.random(),
    },
    {
      cover: 'fb447a78-88ea-4959-b3bf-4a794c9dd6ec.jpeg',
      name: 'Silent Hill 2 Deluxe Edition',
      _id: Math.random(),
    },
    {
      cover: '496d6bbe-2d6a-4198-94ee-efbd8ba07b7d.jpeg',
      name: 'Warhammer 40,000: Space Marine 2',
      _id: Math.random(),
    },
    {
      cover: '8501e37a-a9e6-479c-bbf7-edcf584a619f.jpeg',
      name: 'Metaphor: ReFantazio',
      _id: Math.random(),
    },
  ];
  const randomNum = random(0, testKeys.length - 1);
  return testKeys[randomNum];
};

// Test game for the bonus drop. Returns 1 game.
KeyReveals.getBonusDropGame = () => {
  const testKeys = [
    {
      cover: '01511618-e669-4e3f-9577-b1e070ef0c31.jpeg',
      name: 'Styx: Master of Shadows',
      _id: Math.random(),
    },
    {
      cover: '600de287-b084-4717-abea-f492deb98478.jpeg',
      name: 'Shields of Loyalty',
      _id: Math.random(),
    },
    {
      cover: '52da6b32-f40f-4a5d-b6aa-0bcda77320e3.jpeg',
      name: 'A Tale of Paper: Refolded Edition',
      _id: Math.random(),
    },
    {
      cover: 'a816853b-1ca1-4023-b002-8a1741e4166c.jpeg',
      name: 'Call of Juarez: Bound in Blood',
      _id: Math.random(),
    },
    {
      cover: '062163f8-134d-4d2b-a2dd-f62122d5269f.jpeg',
      name: 'Creepy Tale 3: Ingrid Penance',
      _id: Math.random(),
    },
    {
      cover: '57d977f1-68ba-45d3-9c19-5ebe7ea93c3d.jpg',
      name: 'White Noise 2',
      _id: Math.random(),
    },
    {
      cover: 'e436ce7a-fc94-48dd-a9c8-b353fce58381.jpeg',
      name: 'The Magister',
      _id: Math.random(),
    },
    {
      cover: '1785046b-2b8d-476e-a301-af1fb6359994.jpeg',
      name: 'Sparklite',
      _id: Math.random(),
    },
    {
      cover: 'd280e988-f58f-4aae-ba1c-e07de36bf49d.jpeg',
      name: 'Rebel Galaxy Outlaw',
      _id: Math.random(),
    },
    {
      cover: '2f54ea8d-5999-42cb-967e-b75eae3df9d8.jpg',
      name: 'Mordheim: City of the Damned',
      _id: Math.random(),
    },
    {
      cover: '005e3e50-a243-4eb0-ad61-eeacb942eef5.jpeg',
      name: 'Teslagrad Remastered',
      _id: Math.random(),
    },
    {
      cover: 'ee56bebc-451f-4511-bbf3-37113a4b25d7.jpeg',
      name: 'Plebby Quest: The Crusades',
      _id: Math.random(),
    },
    {
      cover: 'bd0b0cdc-cf6d-4026-bf1e-e8957ce0744c.jpeg',
      name: 'Indiana Jones and the Great Circle',
      _id: Math.random(),
    },
    {
      cover: '1109ab70-a49c-476a-bc1f-025a5ae82e60.jpeg',
      name: 'Kingdom Come: Deliverance II Gold',
      _id: Math.random(),
    },
    {
      cover: 'c52aef04-47a5-4000-9a02-8d6505659521.jpeg',
      name: 'Sid Meier\'s Civilization® VII',
      _id: Math.random(),
    },
    {
      cover: 'f5f48a08-909d-496e-809e-af2d1a95c773.jpeg',
      name: 'Monster Hunter Wilds',
      _id: Math.random(),
    },
  ];
  const randomNum = random(0, testKeys.length - 1);
  return testKeys[randomNum];
};

// Format prize names to remove extra information
KeyReveals.formatProductName = (name) => {
  let formattedName = (name || '');
  if (includes(formattedName, 'voucher:')) {
    formattedName = formattedName.replace('voucher:', '');
  }
  if (includes(formattedName, 'coupon:')) {
    formattedName = formattedName.replace('coupon:', '');
  }
  if (includes(formattedName, 'redeem:')) {
    formattedName = formattedName.replace('redeem:', '');
  }
  if (includes(formattedName, 'bethesda:')) {
    formattedName = formattedName.replace('bethesda:', '');
  }
  return formattedName;
};

// Format DRM for prizes so that the support article is correct
KeyReveals.formatProductDrm = (name, drm) => {
  let drmPlatform = drm;
  if (name && (includes(name.toLowerCase(), 'voucher:') || includes(name.toLowerCase(), 'coupon:'))) {
    drmPlatform = 'coupon';
  }
  if (name && (includes(name.toLowerCase(), 'redeem:') || includes(name.toLowerCase(), 'redeem code:'))) {
    drmPlatform = 'redeem';
  }
  return drmPlatform;
};

// Applying a prize voucher
KeyReveals.applyVoucher = async (code, error, applied) => {
  const appliedVoucher = await store.dispatch(addVoucher(code, null, true));
  if (isEmpty(appliedVoucher)) return error(true);

  const state = store.getState();
  const { voucher: reduxVoucher } = state;

  const voucherCode = get(reduxVoucher, 'voucher.code', false);
  if (voucherCode === code) return applied(true);

  return null;
};

export default KeyReveals;
